var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24 11.127H0v4.868h24v-4.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M24-.003H0v4.898h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 5.885H0v4.2h24v-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 8L0 16.003V-.003L12 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M3.915 5.15l.705 2.175h2.295l-1.852 1.35.705 2.175-1.853-1.342-1.852 1.342.705-2.175-1.853-1.35h2.288l.712-2.175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.985 8H1.837v1.905h4.148V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.772 5.818l-.675-.668-2.182 2.183-2.19-2.183-.668.668L3.24 8l-2.183 2.19.668.66 2.19-2.175 2.182 2.175.675-.66L4.582 8l2.19-2.182z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambique);
export default __webpack_public_path__ + "static/media/Mozambique.2239e667b631bc175686ebeee5ea0c03.svg";
export { ForwardRef as ReactComponent };